// extracted by mini-css-extract-plugin
module.exports = {"inputTitle":"FilterLabel_inputTitle__1oI-Y"};